export default {
  page: {
    products: 18,
    productTemplates: 18,
    creationTemplates: 9,
  },
  toastLength: 5000,
  urls: {
    loginUrl: '/m4b/account/login',
    gtmData: '/m4b/gtm/',
    accountConfiguration: 'account',
    accessoriesConfiguration: 'accessories',
    accessoryPriceConfiguration: 'accessory-price',
    userConfiguration: 'user',
    approvalsConfiguration: 'approvals',
    approvalsCountConfiguration: 'approvals-count',
    orderHistoryConfiguration: 'order-history',
    product: {
      index: 'print-products',
      sizes: 'product-sizes',
    },
    addresses: 'addresses',
  },
  ga: 'UA-66896-15',
  gaCat: 'MBS',
  sentry: {
    dsn: 'https://c965311b0dbf4f618b90c23892d55270@sentry.io/1529638',
    enabled: false,
  },
};
